import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { useAppSelector } from "../../store/store";
import "../../css/testCenter.css";
import { DateFormatter } from "../../functions/commons";
import { isNil, toNumber } from "lodash";
import { useGetTestCenterListMutation } from "../../store/testCenterSlice";
import { TestCenterType } from "../../interfaces/testCenter";
import { DATE_FORMAT7 } from "../../constants/stringConstants";
import TestDescription from "./TestDescription";
import { Modal } from "antd";
import ButtonToggler from "../../components/ButtonsToggler";
import NoInterviews from "../../assets/images/no-interviews.svg";
import PendingIcon from "../../assets/images/PendingIcon.svg";

import Loader from "../../components/Loader";
import CameraTestDescription from "./CameraTestDescription";
import { useLocation } from "react-router-dom";
import ProgressComponent from "../../components/ProgressComponent";

function TestCenter() {
  const { user } = useAppSelector((state) => state["user"]);
  const location = useLocation();
  const [hardSkills, setHardSkills] = useState<any>(null);
  const [softSkills, setSoftSkills] = useState<any>(null);
  const [isHardSkillSelected, setHardSkillSelected] = useState<boolean>(
    location?.state?.isHardSkill ?? true
  );
  const [isTestDescription, setTestDescription] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCameraMessageDescription, setCameraMessageDescription] = useState<boolean>(false);
  const [selectedTest, setSelectedTest] = useState<TestCenterType>();
  const [getTestCenterList] = useGetTestCenterListMutation();

  useEffect(() => {
    getTestsLogDataFromDb();
  }, []);

  const getTestsLogDataFromDb = async () => {
    const whereObj = encodeURIComponent(`
{
  "where":{
	"candidateId":"${user?.id}"
  },
  "include":[
	{
	  "relation":"candidateTests","scope":{"where":{"isAttempted":true}}
	},
	{
	  "relation":"test"
	}
  ]
}
`);

    const payload = {
      filterDetails: whereObj,
    };

    getTestCenterList(payload)
      .unwrap()
      .then((testCenter: Array<TestCenterType>) => {
        console.log({ testCenter });
        let tempHardSkills = {};
        let tempSoftSkills = {};
        let hardAttemptedList: Array<TestCenterType> = [];
        let hardRemainingList: Array<TestCenterType> = [];
        let softAttemptedList: Array<TestCenterType> = [];
        let softRemainingList: Array<TestCenterType> = [];

        testCenter.forEach((element: TestCenterType) => {
          if (element.test.testCategory === "Softskill") {
            if (element.candidateTests?.length! > 0) {
              softAttemptedList.push(element);
            } else {
              softRemainingList.push(element);
            }
          } else {
            if (element.candidateTests?.length! > 0) {
              hardAttemptedList.push(element);
            } else {
              hardRemainingList.push(element);
            }
          }
        });
        tempSoftSkills = {
          attempted: softAttemptedList,
          remaining: softRemainingList,
        };
        tempHardSkills = {
          attempted: hardAttemptedList,
          remaining: hardRemainingList,
        };

        console.log({ tempHardSkills });

        setHardSkills(tempHardSkills);
        setSoftSkills(tempSoftSkills);
        setIsLoading(false);
      });
  };

  const getRetakeTestStatus = (test: TestCenterType) => {
    const createdAt = test.candidateTests![0].createdAt;

    // Convert `createdAt` to a date object
    const createdAtDate: Date = new Date(createdAt);

    // Add 90 days to `createdAtDate`
    const modifiedDate: Date = new Date(createdAtDate.getTime());
    modifiedDate.setDate(modifiedDate.getDate() + 90);

    // Calculate the number of days remaining
    const currentDate: Date = new Date();
    const remainingDays: number = Math.ceil(
      (modifiedDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
    );

    console.log(`Modified Date: ${modifiedDate}`);
    console.log(`Days Remaining: ${remainingDays}`);
    return remainingDays;
  };

  const attemptedTestItem = (test: TestCenterType) => (
    <div className="test_item_container" style={{ paddingLeft: 15 }}>
      <div className="attempted_test_item_content">
        {/* {test?.candidateTests![0].result >= 50 ? (
          <img src={GreenTickModal} style={{ width: "30px", height: "30px" }} />
        ) : (
          <>
            <img
              src={CrossIcon}
              style={{
                width: "16px",
                height: "16px",
                marginLeft: "6px",
                marginRight: "8px",
              }}
            />
          </>
        )} */}

        <ProgressComponent
          type="circle"
          width={40}
          percentage={toNumber(test?.candidateTests![0].result.toFixed(0))}
          showInfo={true}
        />
        <div className="attempted_test_item_text_container">
          <text>{test.test.content}</text>

          <text>{`Attempted ${DateFormatter(
            test.candidateTests![0].createdAt,
            DATE_FORMAT7
          )}`}</text>
        </div>
      </div>
      <div
        className="attempted_test_right_side_text_container"
        onClick={() => {
          if (getRetakeTestStatus(test) <= 0) {
            setCameraMessageDescription(true);
            setSelectedTest(test);
          }
        }}
      >
        <text
          style={{
            color: getRetakeTestStatus(test) >= 1 ? "#89a8dc" : "rgb(47, 192, 47)",
            opacity: getRetakeTestStatus(test) >= 1 ? 0.6 : 1,
          }}
        >
          {`${
            getRetakeTestStatus(test) >= 1
              ? `Retake in ${getRetakeTestStatus(test)} days`
              : "Retake"
          }`}{" "}
        </text>
      </div>
    </div>
  );

  const remainingTestItem = (test: TestCenterType) => (
    <div className="test_item_container">
      <div className="remaining_test_item_content">
        <img src={PendingIcon} style={{ width: "27px", height: "27px" }} />
        <div className="attempted_test_item_text_container">
          <text>{test.test.content}</text>
        </div>
      </div>
      <div
        className="remaining_test_right_side_text_container"
        onClick={() => {
          setCameraMessageDescription(true);
          setSelectedTest(test);
        }}
      >
        <text>Attempt</text>
      </div>
    </div>
  );

  const attemptedTestList = () => (
    <div className="flex_column">
      {isHardSkillSelected
        ? !isNil(hardSkills) &&
          hardSkills.attempted.map((item: TestCenterType) => {
            return attemptedTestItem(item);
          })
        : !isNil(softSkills) &&
          softSkills.attempted.map((item: TestCenterType) => {
            return attemptedTestItem(item);
          })}
    </div>
  );

  const remainingTestList = () => (
    <div className="flex_column">
      {isHardSkillSelected
        ? !isNil(hardSkills) &&
          hardSkills.remaining.map((item: TestCenterType) => {
            return remainingTestItem(item);
          })
        : !isNil(softSkills) &&
          softSkills.remaining.map((item: TestCenterType) => {
            return remainingTestItem(item);
          })}
    </div>
  );

  return (
    <div className="test_center__container" style={{ backgroundColor: "#F4F5F7" }}>
      <Navbar />
      {isLoading ? (
        <Loader loader={isLoading} />
      ) : (
        <div className="test_center__content" style={{ marginTop: 70 }}>
          <div className="header_text_container" style={{ backgroundColor: "#F4F5F7" }}>
            <text className="header_text">Test Center</text>
          </div>

          <div className="test_center_btn_toggler_container">
            <ButtonToggler
              onFirstBtnTap={() => setHardSkillSelected(true)}
              onSecondBtnTap={() => setHardSkillSelected(false)}
              firstBtnText={"Hard Skills"}
              secondBtnText={"Soft Skills"}
              isFirstBtnSelected={isHardSkillSelected}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingLeft: "170px",
            }}
          >
            <div className="tests_container">
              <div className="test_header_text">
                <text>Attempted Tests</text>
              </div>
              <div style={{ flexGrow: 1, minHeight: "100vh" }}>
                {(isHardSkillSelected && !isNil(hardSkills) && hardSkills.attempted.length <= 0) ||
                (!isHardSkillSelected && !isNil(softSkills) && softSkills.attempted.length <= 0) ? (
                  <div style={{ width: "60%", height: "30vh", marginTop: 50 }}>
                    <div>
                      <div className="empty_sec">
                        <img src={NoInterviews} alt="" />
                        <text>No Attempted tests Found</text>
                      </div>
                    </div>
                  </div>
                ) : (
                  attemptedTestList()
                )}
              </div>
            </div>
            <div className="tests_container">
              <div className="test_header_text">
                <text>Remaining Tests</text>
              </div>
              <div style={{ flexGrow: 1, minHeight: "100vh" }}>
                {(isHardSkillSelected && !isNil(hardSkills) && hardSkills.remaining.length <= 0) ||
                (!isHardSkillSelected && !isNil(softSkills) && softSkills.remaining.length <= 0) ? (
                  <div style={{ width: "60%", height: "30vh", marginTop: 50 }}>
                    <div>
                      <div className="empty_sec">
                        <img src={NoInterviews} alt="" />
                        <text style={{textAlign:'center'}}>Test list on standby. Anticipate exciting discoveries soon!</text>
                      </div>
                    </div>
                  </div>
                ) : (
                  remainingTestList()
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isTestDescription && !isNil(selectedTest) && (
        <Modal
          footer={null}
          visible={true}
          className="ant-modal"
          onCancel={(e) => setTestDescription(false)}
        >
          <TestDescription
            testLogId={selectedTest.id}
            testId={selectedTest.testId}
            candidateId={selectedTest.candidateId}
            testData={selectedTest.test}
            onCloseDescriptionModal={() => setTestDescription(false)}
          />
        </Modal>
      )}

      {isCameraMessageDescription && (
        <Modal
          footer={null}
          visible={true}
          className="ant-modal"
          onCancel={(e) => {
            setCameraMessageDescription(false);
            // setTestDescription(true);
          }}
        >
          <CameraTestDescription
            onCloseDescriptionModal={() => {
              setCameraMessageDescription(false);
              setTestDescription(true);
            }}
          />
        </Modal>
      )}
    </div>
  );
}

export default TestCenter;
